import { getMomentTz } from "@dexteel/mesf-core";
import { DatePicker } from "@mui/x-date-pickers";
import React from "react";

type Props = {
	label: string;
	value: Date;
	onChange: (date: Date | null) => void;
};

const moment = getMomentTz();

export const MonthPicker: React.FC<Props> = ({ label, value, onChange }) => {
	const currentDate = new Date();

	return (
		<DatePicker
			openTo="month"
			views={["year", "month"]}
			label={label}
			format="MMMM YYYY"
			value={moment(value)}
			onChange={(momentValue) =>
				onChange(momentValue ? momentValue.toDate() : null)
			}
			maxDate={moment(currentDate)}
			slotProps={{
				textField: {
					variant: "outlined",
					InputProps: {
						style: {
							height: "45px",
							fontSize: "14px",
						},
					},
					sx: {
						"& .MuiInputBase-root": {
							height: "45px",
						},
					},
				},
			}}
			showDaysOutsideCurrentMonth={false}
		/>
	);
};
